import { Outlet } from "react-router-dom";
import Navbar from "../components/navbar/navbar";
import { SidebarProvider } from "@/components/ui/sidebar";

export default function PublicLayout() {
  return (
    <SidebarProvider className="w-full">
      <div className="flex flex-col min-h-screen w-full">
        <Navbar />
        <div id="outlet" className="w-full">
          <Outlet />
        </div>
      </div>
    </SidebarProvider>
  );
}
